module.exports = __webpack_public_path__ + "img/logout.82a8471a.svg";